import cn from 'classnames';
import TextRenderer from '@components/TextRenderer';
import AnimateIn from '@components/AnimateIn';
import Form from './HubspotForm';
import SanityImage from '@components/SanityImage';
import styles from './HubspotFormWithImage.module.css';
import textStyles from '@styles/textStyles.module.css';
import { colorMap } from '@constants/colors';

const HubspotFormWithImage = ({
  eyebrow,
  heading,
  text,
  form,
  image,
  listItems,
  instructions,
  background,
  gradient,
}) => {
  const rootStyle = {
    '--section-background': background && colorMap[background], // Light shade for background
    '--color-background-default': gradient && colorMap[gradient], // Base shade for gradient
  };

  return (
    <section className={styles.root} style={rootStyle}>
      <div className={cn(styles.contentWrapper, styles.sectionWidthSmall)}>
        <div className={styles.formWrapper}>
          {eyebrow && (
            <span className={cn(styles.eyebrow, textStyles.eyebrow)}>
              {eyebrow}
            </span>
          )}
          {heading && (
            <h2 className={cn(styles.heading, textStyles.headlineM)}>
              {heading}
            </h2>
          )}
          {text && (
            <TextRenderer
              text={text}
              as="p"
              className={cn(styles.text, textStyles.bodyL)}
            />
          )}

          <AnimateIn>
            <Form
              form={form}
              instructions={instructions}
              listItems={listItems}
            />
          </AnimateIn>
        </div>
        <div className={styles.imageWrapper}>
          <AnimateIn className={styles.imageAnimateInWrapper}>
            <SanityImage
              asset={image.image}
              alt={image.alt}
              className={styles.image}
            />
          </AnimateIn>
        </div>
      </div>
    </section>
  );
};

export default HubspotFormWithImage;
export { HubspotFormWithImage };
